import { Tree, TreeProps } from "@mcleod/components";
import { DatabaseMenuItem } from "./DatabaseMenuItem";
import { MenuDataSource } from "./MenuDataSource";
import { MenuEditor } from "./MenuEditor";
import { MenuEditorTreeNode } from "./MenuEditorTreeNode";

export interface MenuEditorTreeProps extends TreeProps {
    menuEditor: MenuEditor;
    menuDataSource: MenuDataSource;
}

export class MenuEditorTree extends Tree<MenuEditorTreeNode> {
    menuEditor: MenuEditor;
    menuDataSource: MenuDataSource;

    constructor(props: Partial<MenuEditorTreeProps>) {
        super(props);
        this.menuDataSource.addChangedDataCallback(this.menuDataChanged.bind(this));
    }

    private menuDataChanged() {
        if (this.menuDataSource.isLoadingData()) {
            this.populate();
        } else {
            this.refresh();
        }
    }

    get menuData(): DatabaseMenuItem {
        return this.menuDataSource.menuData;
    }

    private refresh() {
        this.getAllNodes((node: MenuEditorTreeNode) => node.expanded)
            .forEach(node => node.menuItem["__wasExpanded"] = true);
        this.populate();
    }

    private populate() {
        if (!this.menuData || !this.menuData.items) {
            return;
        }
        this.getRootNode().removeAllChildren();
        const mainMenu = new MenuEditorTreeNode({ menuItem: this.menuData, menuEditor: this.menuEditor, expanded: true });
        this.getRootNode().setChildren([mainMenu]);
        this.selectedNode = null;
    }

    public getAllNodes(matchFunction: (node: MenuEditorTreeNode) => boolean): MenuEditorTreeNode[] {
        return this.getRootNode().getRecursiveChildNodes(matchFunction) as MenuEditorTreeNode[];
    }

    public forEveryNode(callback: (node: MenuEditorTreeNode) => void) {
        this.getRootNode().recurseChildren(callback);
    }

    public findFirstNode(matchFunction: (node: MenuEditorTreeNode) => boolean): MenuEditorTreeNode | null {
        return this.getRootNode().findFirstChildNode(matchFunction) as MenuEditorTreeNode;
    }

    public selectAndExpandParents(node: MenuEditorTreeNode) {
        node?.recurseParents(parent => {
            if (parent instanceof MenuEditorTreeNode) {
                parent.expandWithoutTransition(true);
            } else {
                parent.expanded = true;
            }
        });
        this.selectedNode = node;
        this.scrollToSelection();
    }
}
